// extracted by mini-css-extract-plugin
export var addButton = "_g5-0";
export var border = "_g5-8";
export var check = "_g5-h";
export var danger = "_g5-6";
export var dropdownContainer = "_g5-1";
export var editModalBody = "_g5-j";
export var footerContainer = "_g5-i";
export var fullWidth = "_g5-a";
export var hide = "_g5-9";
export var icon = "_g5-3";
export var input = "_g5-7";
export var inputFlex = "_g5-b";
export var inputWrapper = "_g5-c";
export var manualFocus = "_g5-5";
export var optionButton = "_g5-4";
export var pillWrapper = "_g5-e";
export var pointer = "_g5-2";
export var showOverflow = "_g5-f";
export var tagsFlex = "_g5-d";
export var xButton = "_g5-g";